import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element'
import './plugins/editor'
import axios from 'axios'
import VueAxios from 'vue-axios'
import property from '../vue-property'


Vue.use(VueAxios, axios)
Vue.use(property)  // 全局变量
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
